'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var rotateInUpLeft = {
  from: {
    transformOrigin: 'left bottom',
    transform: (0, _utils.rotate3d)(0, 0, 1, 45),
    opacity: 0
  },
  to: {
    transformOrigin: 'left bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInUpLeft;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/rotate-in-up-left.js
// module id = 245
// module chunks = 54990529738226 257444579329143